import { useQuery } from '@tanstack/react-query';

import { api } from '../../../config/ApiConfig';
import { hasAuthSession } from '../../../utils/authTokenStorage';

export const useMeQuery = () => {
  const hasSession = hasAuthSession();

  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get('/v1/user/me').then((response) => response.data),
    enabled: hasSession,
    retry: false,
    meta: {
      suppressErrorToast: true,
    },
  });
};
